import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { classes } from '../lib/divers';
import { Rouet } from './Chargement';

export type VarianteBouton = 'neutre' | 'primaire' | 'danger' | 'discret';

interface ProprietesBouton extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: VarianteBouton;
  petit?: boolean;
  pleineLargeur?: boolean;
  /** Affiche un indicateur d'activité et désactive le bouton. */
  occupe?: boolean;
  children: ReactNode;
}

const CLASSE_VARIANTE: Record<VarianteBouton, string> = {
  neutre: '',
  primaire: 'gv-bouton--primaire',
  danger: 'gv-bouton--danger',
  discret: 'gv-bouton--discret',
};

export function Bouton({
  variante = 'neutre',
  petit = false,
  pleineLargeur = false,
  occupe = false,
  disabled,
  className,
  children,
  type = 'button',
  ...reste
}: ProprietesBouton): JSX.Element {
  return (
    <button
      type={type}
      className={classes(
        'gv-bouton',
        CLASSE_VARIANTE[variante],
        petit && 'gv-bouton--petit',
        pleineLargeur && 'gv-bouton--pleine-largeur',
        className,
      )}
      disabled={disabled === true || occupe}
      aria-busy={occupe || undefined}
      {...reste}
    >
      {occupe ? <Rouet /> : null}
      {children}
    </button>
  );
}

/** Lien interne stylé en bouton — pour les actions qui sont en réalité des navigations. */
export function BoutonLien({
  vers,
  variante = 'neutre',
  petit = false,
  children,
}: {
  vers: string;
  variante?: VarianteBouton;
  petit?: boolean;
  children: ReactNode;
}): JSX.Element {
  return (
    <Link
      to={vers}
      className={classes('gv-bouton', CLASSE_VARIANTE[variante], petit && 'gv-bouton--petit')}
    >
      {children}
    </Link>
  );
}
